import React, { useState } from 'react';
import { getImageUrl, getAllImageUrls } from '../../services/api';

const ProductGallery = ({ product }) => {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  if (!product) {
    return null;
  }

  // Get all images or use single image
  const images = product.Image 
    ? (Array.isArray(product.Image) ? getAllImageUrls(product.Image, 'large') : [getImageUrl(product.Image, 'large')])
    : [];

  const thumbnails = product.Image 
    ? (Array.isArray(product.Image) ? getAllImageUrls(product.Image, 'thumbnail') : [getImageUrl(product.Image, 'thumbnail')])
    : [];

  const hasImages = images.length > 0;

  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          {/* Main Image */}
          <div className="relative w-full h-96 md:h-[500px] bg-white">
            {hasImages ? (
              <img
                src={images[selectedImageIndex]}
                alt={product.Title}
                className="w-full h-full object-contain"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <div className="text-center">
                  <svg className="w-24 h-24 text-gray-400 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  <p className="text-gray-500 text-lg">No image available</p>
                </div>
              </div>
            )}
          </div>

          {/* Thumbnail Gallery */}
          {images.length > 1 && (
            <div className="p-4 bg-white border-t border-gray-200">
              <div className="flex gap-3 overflow-x-auto">
                {thumbnails.map((thumbnail, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImageIndex(index)}
                    className={`flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all duration-300 ${
                      selectedImageIndex === index
                        ? 'border-catalina-blue shadow-md'
                        : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <img
                      src={thumbnail}
                      alt={`${product.Title} - View ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ProductGallery;